import { message, Modal, ModalFuncProps, Spin } from 'antd';
import { createRoot } from 'react-dom/client';

export default {
  error: function (s: string) {
    return message.error(s);
  },
  msg: function (s: string) {
    return message.success(s);
  },
  warn: function (s: string) {
    return message.warn(s);
  },
  info: function (s: string) {
    return message.info(s);
  },
  confirm: function (props: ModalFuncProps = {
    title: ''
  }) {
    return Modal.confirm({
      ...props,
      centered: true
    });
  },
  alert: function (props: ModalFuncProps) {
    if (!props.okText) {
      props.okText = '我知道了';
    }
    return Modal.success({
      ...props,
      centered: true
    });
  },
  loading () {
    const loadingNode = document.querySelectorAll('.uni-loading');
    if (loadingNode && loadingNode.length > 0) return false;
    const container = document.createElement('div');
    container.classList.add('uni-loading');
    document.body.appendChild(container);
    const root = createRoot(container);
    root.render(<Spin size='large' />);
  },
  closeLoading () {
    const loadingNode = document.querySelectorAll('.uni-loading');
    loadingNode.forEach(i => {
      document.body.removeChild(i);
    });
  }
};